import * as React from 'react';
import { PublishTermsLoader } from './PublishTermsLoader';
import { useIsMobileDevice } from '../../../../hooks';

export const PublishTermsLoaderContainer: React.FC<{}> = () => {
  const isMobile = useIsMobileDevice();

  return <PublishTermsLoader isMobile={isMobile} />;
};
